<template>

    <!-- Slider -->
    <div class="grid grid-cols-1">
        <Slider />
    </div>
    <section class="p-10 pb-10  2xl:px-96">
        <!-- Main Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div class="bg-gray-100 py-3 px-5 rounded-md text-green-600 h-80">
                <ul>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#TentangBaznas">Tentang Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#VisiBaznas">Visi Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#MisiBaznas">Misi Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#TujuanBaznas">Tujuan Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#SasaranBaznas">Sasaran Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#PimpinanBaznas">Pimpinan Baznas</a></li>
                    <li class="py-1 font-semibold border-b uppercase"><a href="#DireksiBaznas">Direksi Baznas</a></li>
                </ul>
            </div>
            <div class="h-full w-full col-span-2 px-5">
                <div class="border-b pb-5">
                    <h1 class="font-bold text-xl uppercase text-green-600" id="TentangBaznas">Tentang Baznas</h1>
                    <p class="py-1">Badan Amal Zakat Nasional (BAZNAS) merupakan badan resmi dan satu-satunya yang dibentuk oleh pemerintah berdasarkan Keputusan Presiden RI No.8 Tahun 2001 yang memiliki tugas dan fungsi menghimpun dan menyalurkan zakat, infaq, dan sedekah (ZIS) pada tingkat nasional. Lahirnya Undang-Undang Nomor 23 Tahun 2011 tentang Pengelolaan Zakat. Dalam UU tersebut, BAZNAS  dinyatakan sebagai lembaga pemerintah nonstruktural</p>
                </div>
                <div class="border-b py-5">
                    <h1 class="font-bold text-xl uppercase text-green-600" id="VisiBaznas">Visi Baznas</h1>
                    <p class="py-1">Menjadi Lembaga Utama yang menyejahterakan umat</p>
                </div>
                <div class="border-b py-5">
                    <h1 class="font-bold text-xl uppercase text-green-600" id="MisiBaznas">Misi Baznas</h1>
                    <p class="py-1">1. Membangun BAZNAS Kota Samarinda yang kuat, terpercaya, dan modern sebagai lembaga pemerintah non-struktural yang berwenang dalam pengelolaan zakat.</p>
                    <p class="py-1">2. Memaksimalkan literasi zakat di kota Samarinda dan peningkatan pengumpulan ZIS-DSKL secara masif dan struktural</p>
                    <p class="py-1">3. Memaksimalkan pendistribusian dan pedayagunaan ZIS-DSKL untuk mengentaskan kemiskinan, meingkatkan kesejahteraan umat, dan mengurangi kesenjangan sosial.</p>
                    <p class="py-1">4. Modernisasi dan digitalisasi pengelolaan zakat kota Samarinda dengan sistem manajemen berbasis data yang kokoh dan terstruktur</p>
                    <p class="py-1">5. Meningkatkan sinergi dan kolaborasi seluruh pemangku kepentingan terkait untuk pembangunan zakat kota Samarinda</p>
                </div>
                <div class="border-b py-5">
                    <h1 class="font-bold text-xl uppercase text-green-600" id="TujuanBaznas">Tujuan Baznas</h1>
                    <p class="py-1">1. Terwujudnya BAZNAS sebagai lembaga pengelola zakat yang kuat, terpercaya, dan modern</p>
                    <p class="py-1">2. Terwujudnya pengumpulan zakat nasional yang optimal;</p>
                    <p class="py-1">3. Terwujudnya profesi amil zakat nasional yang kompeten, berintegritas, dan sejahtera;</p>
                    <p class="py-1">4. Modernisasi dan digitalisasi pengelolaan zakat kota Samarinda dengan sistem manajemen berbasis data yang kokoh dan terstruktur</p>
                    <p class="py-1">5. Terwujudnya sistem manajemen dan basis data pengelolaan zakat nasional yang mengadopsi teknologi mutakhir;</p>
                    <p class="py-1">6. Terwujudnya perencanaan, pengendalian, pelaporan, dan pertanggungjawaban pengelolaan zakat dengan kelola yang baik dan terstandar;</p>
                    <p class="py-1">7. Terwujudnya hubungan saling tolong menolong dalam kebaikan dan ketakwaan antara muzakki dan mustahik;</p>
                    <p class="py-1">8. Terwujudnya sinergi dan kolaborasi seluruh pemangku kepentingan terkait dalam pembangunan zakat nasional;</p>
                    <p class="py-1">9. Terwujudnya Indonesia sebagai center of excellence pengelolaan zakat dunia.</p>
                </div>
                <div class="border-b py-5">
                    <h1 class="font-bold text-xl uppercase text-green-600" id="SasaranBaznas">Sasaran Baznas</h1>
                    <p class="py-1">1.  Meningkatkan kualitas pelayanan kepada muzakki, mustahik, dan stakeholder lainnya;</p>
                    <p class="py-1">2.  Meningkatkan kesadaran masyarakat untuk menunaikan zakat melalui OPZ resmi;</p>
                    <p class="py-1">3.  Meningkatkan pertumbuhan pengumpulan zakat nasional;</p>
                    <p class="py-1">4.  Meningkatkan kualitas pelayanan kepada mustahik dan penerima manfaat ZIS-DSKL;</p>
                    <p class="py-1">5.  Meningkatkan manfaat ZIS-DSKL dalam upaya pengentasan kemiskinan, peningkatan kesejahteraan ummat, dan pengurangan kesenjangan sosial;</p>
                    <p class="py-1">6.  Meningkatkan kualitas dan pelaksanaan Standar Kompetensi Kerja Nasional Indonesia (SKK-NI) Sektor Zakat;</p>
                    <p class="py-1">7.  Mendorong pembentukan dan pengembangan asosiasi profesi amil zakat Indonesia;</p>
                    <p class="py-1">8.  Membangun merit system dalam pengelolaan SDM amil zakat pada OPZ;</p>
                    <p class="py-1">9.  Mengembangkan sistem manajemen dan basis data pengelolaan zakat nasional;</p>
                    <p class="py-1">10. Memperkuat infrastruktur teknologi informasi dalam menunjang operasional pelayanan BAZNAS dan LAZ;</p>
                    <p class="py-1">11. Memperkuat basis data muzakki, mustahik, dan amil zakat nasional;</p>
                    <p class="py-1">12. Memperkuat riset untuk pengembangan produk dan kebijakan pengelolaan zakat secara nasional;</p>
                    <p class="py-1">13. Mengembangkan sistem perencanaan zakat nasional dengan tata kelola yang baik dan terstandar;</p>
                    <p class="py-1">14. Mengembangkan sistem pengendalian zakat nasional dengan tata kelola yang baik dan terstandar;</p>
                    <p class="py-1">15. Mengembangkan sistem pelaporan dan pertanggungjawaban pengelolaan zakat nasional dengan tata kelola yang baik dan terstandar;</p>
                    <p class="py-1">16. Mengembangkan program partisipasi muzakki dan mustahik dalam pengelolaan zakat;</p>
                    <p class="py-1">17. Mengembangkan sinergi dan kolaborasi OPZ dalam sosialisasi dan edukasi zakat nasional;</p>
                    <p class="py-1">18. Mengembangkan sinergi dan kolaborasi OPZ dalam pendistribusian dan pendayagunaan zakat nasional;</p>
                    <p class="py-1">19. Mengembangkan sinergi dan kolaborasi pengelolaan zakat nasional dengan pemerintahan pusat dan pemerintahan daerah;</p>
                    <p class="py-1">20. Mengembangkan sinergi dan kolaborasi pengelolaan zakat nasional dengan pihak swasta dan lembaga non-pemerintah;</p>
                    <p class="py-1">21. Meningkatkan pengakuan masyarakat dunia atas pengelolaan zakat Indonesia</p>
                </div>
                <div class="border-b py-5">
                    <h1 class="font-bold text-xl uppercase text-green-600 pb-5" id="PimpinanBaznas">Pimpinan Baznas</h1>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-5">
                        <div class="bg-hijau rounded-lg">
                            <img src="https://i.ibb.co/mhscCxN/w1-min.png" alt="Foto" class="w-full h-auto object-top object-cover rounded-t-md">
                            <div class="text-center py-3">
                                <h3 class="font-bold text-white text-xl uppercase">H. Widyasmoro Eko Prawito,S.E, MH</h3>
                                <p class="text-white text-sm">Ketua</p>
                            </div>
                        </div>
                        
                        <div class="bg-hijau rounded-lg">
                            <img src="https://i.ibb.co/9G3L8Pg/s3-min.png" alt="Foto" class="w-full h-auto object-top object-cover rounded-t-md">
                            <div class="text-center py-3">
                                <h3 class="font-bold text-white text-xl uppercase">Ahmad Syahir Idris,S.E, C.P.NLP</h3>
                                <p class="text-white text-sm">Wakil Ketua 1</p>
                            </div>
                        </div>
                        
                        <div class="bg-hijau rounded-lg">
                            <img src="https://i.ibb.co/DVDDvcq/R-min.png" alt="Foto" class="w-full h-auto object-top object-cover rounded-t-md">
                            <div class="text-center py-3">
                                <h3 class="font-bold text-white text-xl uppercase">H. Ahmad Imam Royani, S.HI</h3>
                                <p class="text-white text-sm">Wakil Ketua 2</p>
                            </div>
                        </div>

                        <div class="bg-hijau rounded-lg">
                            <img src="https://i.ibb.co/QMTzSPW/s2-min.png" alt="Foto" class="w-full h-auto object-top object-cover rounded-t-md">
                            <div class="text-center py-3">
                                <h3 class="font-bold text-white text-xl uppercase">Moh. Syamsul Hadi, S.Ag, MH</h3>
                                <p class="text-white text-sm">Wakil Ketua 3</p>
                            </div>
                        </div>

                        <div class="bg-hijau rounded-lg">
                            <img src="https://i.ibb.co/B4t1mPy/S1-min.png" alt="Foto" class="w-full h-auto object-top object-cover rounded-t-md">
                            <div class="text-center py-3">
                                <h3 class="font-bold text-white text-xl uppercase">Ir. H. Akhmad Sirodz,MP</h3>
                                <p class="text-white text-sm">Wakil Ketua 4</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <WhatsappButton/>
</template>

<script>

    //component slider
    import Slider from '@/components/Slider.vue'

    // component WhatsappButton
    import WhatsappButton from '@/components/WhatsappButton.vue'

    export default {

        components: {
            Slider,         // <-- register component slider
            WhatsappButton,
        },

        setup() {
            return {

            }
        }
    }
</script>
